<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <label for="form-pass-region" class="control-label">{{ inputLabel }}</label>
    <select
      id="form-pass-region"
      class="show-tick form-control"
      v-model="inputValue"
      @input="emit"
      @change="emit"
      @blur="emit"
      :disabled="disabled"
    >
      <option
        v-for="region in items"
        v-bind:key="region.id"
        :value="region.id"
      >{{ region.short_name }}
      </option>
    </select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'

export default {
  name: 'TerminalRegionInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Территория посещения'
    },

    inputName: {
      default: 'terminal_region_id'
    },

    items: {
      type: [Array, Object],
      default: () => []
    }
  },

  created() {
    if (this.items.length === 1) {
      this.inputValue = this.items?.[0]?.id
      this.emitValue('change', this.items?.[0]?.id) // handling changeTerminalId
    }
  },

  watch: {
    items(value) {
      if (value.length === 1) {
        this.inputValue = value?.[0]?.id
        this.emitValue('change', value?.[0]?.id)
      }
    }
  }
}
</script>
